import React, { useEffect, KeyboardEvent, } from 'react';
import { useForm } from "react-hook-form"


import icon_search from '../../../assets/img/common/icon_search.svg';

import constant from '../../../Constant';
import {
    getTypeOfBudgetSearchTextList,
    getTypeOfBudgetYosanTextList,
    getRunningTitleYosanTextList1,
    getRunningTitleYosanTextList2,
    getTypeOfBudgetKessanTextList,
    getRunningTitleKessanTextList1,
    getRunningTitleKessanTextList2
} from '../../../functions/Utitilty';

import Accordion from '../../../components/Accordion';

import YosanDialog, { YosanDialogRef, YosanDialogValues } from './YosanDialog';
import KessanDialog, { KessanDialogRef, KessanDialogValues } from './KessanDialog';

export const getSearchValues = () => {
    try {
        const values = sessionStorage.getItem('searchValues');
        if (values) {
            return JSON.parse(values);
        } else {
            return undefined;
        }
    } catch (e) {
        return undefined;
    }
}
export const setSearchValues = (values:SearchFormValues) => {
    try {
        sessionStorage.setItem('searchValues', JSON.stringify(values));
    } catch (e) {
        //
    }
}
export const clearSearchValues = () => {
    sessionStorage.removeItem('searchValues');
}
export type SearchFormValues = {
    searchWord: string;
    //searchOrAnd: string;
    searchSort: string;
    selectFiscalYearLeft: string;
    selectFiscalYearRight: string;
    page: number;
    chkInfoYosan: string | undefined;
    chkInfoKessan: string | undefined;
    typeOfBudgetSearchList: string[];
    typeOfBudgetYosanItemList: number[];
    runningTitleYosanItemList1: number[];
    runningTitleYosanItemList2: number[];
    typeOfBudgetKessanItemList: number[];
    runningTitleKessanItemList1: number[];
    runningTitleKessanItemList2: number[];
}
export const defaultValues:SearchFormValues = {
    searchWord: '',
    searchSort: 'new',
    selectFiscalYearLeft: constant.search.FISCAL_YEAR_LIST[0].value,
    selectFiscalYearRight: constant.search.FISCAL_YEAR_LIST[0].value,
    page: 1,
    chkInfoYosan: '',
    chkInfoKessan: '',
    typeOfBudgetSearchList: [],
    typeOfBudgetYosanItemList: [],
    runningTitleYosanItemList1: [],
    runningTitleYosanItemList2: [],
    typeOfBudgetKessanItemList: [],
    runningTitleKessanItemList1: [],
    runningTitleKessanItemList2: [],
}

type SearchFormProps = {
    accordionOpen?: boolean;
    values?: SearchFormValues;
    onSearch: (formData:any) => void;
}
const SearchForm:React.FC<SearchFormProps> = (props) => {
    
    const { accordionOpen = false, values = defaultValues, onSearch } = props;

    // フォームのバリデーション
    const { register, handleSubmit, setValue, getValues, watch, formState: { errors },} = useForm<SearchFormValues>();
    const formValidate = {
        'searchWord': {
            required: { value: true, message: '検索キーワードを入力してください。'},
            //maxLength: { value: 100, message: '検索キーワードには空白を除き1から100文字の範囲で指定してください。'},
            validate: (value:string) => {

                value = value.trim();   // トリムしてからチェックを実施
                if (value.length <= 0) {
                    return '検索キーワードを入力してください。';
                }

                value = value.replaceAll('　', ' ');    // 全角スペースを半角スペースに変更
                value = value.replaceAll(/ +/g, ' ');  // 半角スペースが連続する場合１つに集約する

                const temp = value.trim().split(' OR ');

                // 分割できない場合はAND条件と判定
                if (temp.length === 1) {
                    return;
                }

                // 「 （半角スペース)」が含まれていればANDの混在と判定
                let ret = false;
                temp.map((v:string) => {
                    if (v.indexOf(' ') > -1) {
                        ret = true;
                    }
                });
                if (ret) {
                    return 'AND検索とOR検索の指定が混在した検索はできません。OR検索の場合は、すべての区切りに「スペースとOR（半角大文字)とスペース」を入力してください。';
                }
            }
        }
    };


    /**
     * 表示制御
     */
    // ボタン制御
    const watchChkInfoYosan = watch('chkInfoYosan', values.chkInfoYosan);
    const watchChkInfoKessan = watch('chkInfoKessan', values.chkInfoKessan);

    // 予算書情報絞り込み条件
    // 予算種別
    const watchTypeOfBudgetSearchList = watch('typeOfBudgetSearchList', values.typeOfBudgetSearchList);
    // 冊子名
    const watchtTypeOfBudgetYosanItemList = watch('typeOfBudgetYosanItemList', values.typeOfBudgetYosanItemList);
    // 所管
    const watchRunningTitleYosanItemList1 = watch('runningTitleYosanItemList1', values.runningTitleYosanItemList1);
    const watchRunningTitleYosanItemList2 = watch('runningTitleYosanItemList2', values.runningTitleYosanItemList2);

    // 決算書情報絞り込み条件
    // 冊子名
    const watchtTypeOfBudgetKessanItemList = watch('typeOfBudgetKessanItemList', values.typeOfBudgetKessanItemList);
    // 所管
    const watchRunningTitleKessanItemList1 = watch('runningTitleKessanItemList1', values.runningTitleKessanItemList1);
    const watchRunningTitleKessanItemList2 = watch('runningTitleKessanItemList2', values.runningTitleKessanItemList2);

    // ダイアログ
    const yosanDialogRef = React.useRef<YosanDialogRef>(null);
    const kessanDialogRef = React.useRef<KessanDialogRef>(null);
    const handleYosanDialogShow = () => {
        if (!watchChkInfoYosan) return;
        // 値設定
        const typeOfBudgetSearchList = getValues('typeOfBudgetSearchList');
        const typeOfBudgetYosanItemList = getValues('typeOfBudgetYosanItemList');
        const runningTitleYosanItemList1 = getValues('runningTitleYosanItemList1');
        const runningTitleYosanItemList2 = getValues('runningTitleYosanItemList2');
        yosanDialogRef.current?.set({
            'typeOfBudgetSearchList': typeOfBudgetSearchList,
            'typeOfBudgetYosanItemList': typeOfBudgetYosanItemList?.map((value:number) => { return String(value)}),
            'runningTitleYosanItemList1': runningTitleYosanItemList1?.map((value:number) => { return String(value)}),
            'runningTitleYosanItemList2': runningTitleYosanItemList2?.map((value:number) => { return String(value)})
        });
        // 表示
        yosanDialogRef.current?.show();
    }
    const handleYosanDialogClose = (values:YosanDialogValues) => {

        const typeOfBudgetSearchList:string[] = [];
        if (values.typeOfBudgetSearchList) {
            values.typeOfBudgetSearchList.map((v:string) => {
                typeOfBudgetSearchList.push(v);
            });
        }

        // ダイアログからの返却値はstring型配列になるためnumber型配列に変換
        const typeOfBudgetYosanItemList:number[] = [];
        if (values.typeOfBudgetYosanItemList) {
            values.typeOfBudgetYosanItemList.map((v:string) => {
                typeOfBudgetYosanItemList.push(Number(v));
            });
        }
        const runningTitleYosanItemList1:number[] = [];
        if (values.runningTitleYosanItemList1) {
            values.runningTitleYosanItemList1.map((v:string) => {
                runningTitleYosanItemList1.push(Number(v));
            });
        }
        const runningTitleYosanItemList2:number[] = [];
        if (values.runningTitleYosanItemList2) {
            values.runningTitleYosanItemList2.map((v:string) => {
                runningTitleYosanItemList2.push(Number(v));
            });
        }

        // フォーム値に設定する
        setValue('typeOfBudgetSearchList', typeOfBudgetSearchList);
        setValue('typeOfBudgetYosanItemList', typeOfBudgetYosanItemList);
        setValue('runningTitleYosanItemList1', runningTitleYosanItemList1);
        setValue('runningTitleYosanItemList2', runningTitleYosanItemList2);
    }
    const handleKessanDialogShow = () => {
        if (!watchChkInfoKessan) return;
        // 値設定
        const typeOfBudgetKessanItemList = getValues('typeOfBudgetKessanItemList');
        const runningTitleKessanItemList1 = getValues('runningTitleKessanItemList1');
        const runningTitleKessanItemList2 = getValues('runningTitleKessanItemList2');
        kessanDialogRef.current?.set({
            'typeOfBudgetKessanItemList': typeOfBudgetKessanItemList?.map((value:number) => { return String(value)}),
            'runningTitleKessanItemList1': runningTitleKessanItemList1?.map((value:number) => { return String(value)}),
            'runningTitleKessanItemList2': runningTitleKessanItemList2?.map((value:number) => { return String(value)})
        });
        // 表示
        kessanDialogRef.current?.show();
    }
    const handleKessanDialogClose = (values:KessanDialogValues) => {

        // ダイアログからの返却値はstring型配列になるためnumber型配列に変換
        const typeOfBudgetKessanItemList:number[] = [];
        if (values.typeOfBudgetKessanItemList) {
            values.typeOfBudgetKessanItemList.map((v:string) => {
                typeOfBudgetKessanItemList.push(Number(v));
            });
        }
        const runningTitleKessanItemList1:number[] = [];
        if (values.runningTitleKessanItemList1) {
            values.runningTitleKessanItemList1.map((v:string) => {
                runningTitleKessanItemList1.push(Number(v));
            });
        }
        const runningTitleKessanItemList2:number[] = [];
        if (values.runningTitleKessanItemList2) {
            values.runningTitleKessanItemList2.map((v:string) => {
                runningTitleKessanItemList2.push(Number(v));
            });
        }

        // フォーム値に設定する
        setValue('typeOfBudgetKessanItemList', typeOfBudgetKessanItemList);
        setValue('runningTitleKessanItemList1', runningTitleKessanItemList1);
        setValue('runningTitleKessanItemList2', runningTitleKessanItemList2);
    }

    /**
     * イベントハンドラ
     */
    // キー押下イベント
    const handleYosanKeyDown = (e: KeyboardEvent) => {
        if (!watchChkInfoYosan) return;
        // Enter or Spaceキー押下時
        if (e.code == 'Enter' || e.code == 'Space') {
            e.preventDefault(); // イベント伝播を止める
            handleYosanDialogShow();
        }
    };
    const handleKessanKeyDown = (e: KeyboardEvent) => {
        if (!watchChkInfoKessan) return;
        // Enter or Spaceキー押下時
        if (e.code == 'Enter' || e.code == 'Space') {
            e.preventDefault(); // イベント伝播を止める
            handleKessanDialogShow();
        }
    };
    // 検索条件パラメータの取得
    const handleSearch = (formData:SearchFormValues) => {

        // 予算書から絞り込むチェックが無ければクリア
        if (!formData.chkInfoYosan) {
            formData.chkInfoYosan = undefined;
            formData.typeOfBudgetSearchList = defaultValues.typeOfBudgetSearchList;
            formData.typeOfBudgetYosanItemList = defaultValues.typeOfBudgetYosanItemList;
            formData.runningTitleYosanItemList1 = defaultValues.runningTitleYosanItemList1;
            formData.runningTitleYosanItemList2 = defaultValues.runningTitleYosanItemList2;
        }

        // 決算書から絞り込むチェックが無ければクリア
        if (!formData.chkInfoKessan) {
            formData.chkInfoKessan = undefined;
            formData.typeOfBudgetKessanItemList = defaultValues.typeOfBudgetKessanItemList;
            formData.runningTitleKessanItemList1 = defaultValues.runningTitleKessanItemList1;
            formData.runningTitleKessanItemList2 = defaultValues.runningTitleKessanItemList2;
        }

        onSearch(formData); // 上位に渡す
    }
    // 検索条件クリア
    const handleClear = () => {
        // ダイアログの選択をクリア
        yosanDialogRef.current?.clear();
        kessanDialogRef.current?.clear();

        // フォーム値を初期化
        //setValue('selectFiscalYearLeft', defaultValues.selectFiscalYearLeft);
        //setValue('selectFiscalYearRight', defaultValues.selectFiscalYearRight);
        setValue('page', defaultValues.page);
        setValue('chkInfoYosan', defaultValues.chkInfoYosan);
        setValue('chkInfoKessan', defaultValues.chkInfoKessan);
        setValue('typeOfBudgetSearchList', defaultValues.typeOfBudgetSearchList);
        setValue('typeOfBudgetYosanItemList', defaultValues.typeOfBudgetYosanItemList);
        setValue('runningTitleYosanItemList1', defaultValues.runningTitleYosanItemList1);
        setValue('runningTitleYosanItemList2', defaultValues.runningTitleYosanItemList2);
        setValue('typeOfBudgetKessanItemList', defaultValues.typeOfBudgetKessanItemList);
        setValue('runningTitleKessanItemList1', defaultValues.runningTitleKessanItemList1);
        setValue('runningTitleKessanItemList2', defaultValues.runningTitleKessanItemList2);
    }


    /*
    * フォーム値の初期化
    */
    useEffect(() => {
        //
        setValue('searchWord', values.searchWord);
        setValue('selectFiscalYearLeft', values.selectFiscalYearLeft);
        setValue('selectFiscalYearRight', values.selectFiscalYearRight);
        // 予算書
        setValue('chkInfoYosan', values.chkInfoYosan);
        setValue('typeOfBudgetSearchList', values.typeOfBudgetSearchList);
        setValue('typeOfBudgetYosanItemList', values.typeOfBudgetYosanItemList);
        setValue('runningTitleYosanItemList1', values.runningTitleYosanItemList1);
        setValue('runningTitleYosanItemList2', values.runningTitleYosanItemList2);
        // 決算書
        setValue('chkInfoKessan', values.chkInfoKessan);
        setValue('typeOfBudgetKessanItemList', values.typeOfBudgetKessanItemList);
        setValue('runningTitleKessanItemList1', values.runningTitleKessanItemList1);
        setValue('runningTitleKessanItemList2', values.runningTitleKessanItemList2);
    }, [values])

    //
    return (
    <>
        <form noValidate={true} onSubmit={handleSubmit(handleSearch)}>
        <div className="c-blk-txt c-blk-txt--split">
        <div className="c-search-wrap">
            <label htmlFor="searchWord" className="u-sr-only">検索したい用語を入力してください。</label>
            <input type="text" id="searchWord" className="c-input-text c-search-input" placeholder="検索したい用語を入力してください。" minLength={1} maxLength={100} {...register("searchWord", formValidate["searchWord"])} required={true} aria-required="true" aria-describedby={(errors.searchWord)?"searchError":undefined} aria-invalid={(errors.searchWord)?"true":"false"} aria-label="検索語句入力"/>
            <button type="submit" className="c-button c-button--lg c-search-button">
            <span className="c-button__icon"><span className="c-icon"><svg width={18} height={18} aria-label="検索する"><use href={`${icon_search}#iconSearch`} /></svg></span></span>
            <span className="c-button__txt">検索</span>
            </button>
        </div>
        {errors.searchWord &&
        <p id="searchError" className="c-text--error" aria-live="polite">{errors.searchWord.message}</p>
        }
        </div>
        <div className="c-blk-txt c-blk-txt--lg">
        <Accordion open={accordionOpen} title="検索対象の絞り込み条件">
            <div className="c-form-item">
                <fieldset>
                <legend className="c-form-item__label">年度を指定</legend>
                <div className="c-form-item__input">
                    <span className="c-select-wrap">
                    <label htmlFor="selectFiscalYearLeft" className="c-form-item__label u-sr-only">開始年度を指定</label>
                    <select id="selectFiscalYearLeft" className="c-select c-select--year" {...register("selectFiscalYearLeft")} >
                    {constant.search.FISCAL_YEAR_LIST.map((fiscal_year:any) => (
                        <option value={fiscal_year.value}>{fiscal_year.text}</option>
                    ))}
                    </select>
                    <span className="c-select-wrap__unit">年度</span>
                    </span>
                    <span className="c-form-item__input__separate">〜</span>
                    <span className="c-select-wrap">
                    <label htmlFor="selectFiscalYearRight" className="c-form-item__label u-sr-only">終了年度を指定</label>
                    <select id="selectFiscalYearRight" className="c-select c-select--year" {...register("selectFiscalYearRight")} >
                    {constant.search.FISCAL_YEAR_LIST.map((fiscal_year:any) => (
                        <option value={fiscal_year.value}>{fiscal_year.text}</option>
                    ))}
                    </select>
                    <span className="c-select-wrap__unit">年度</span>
                    </span>
                </div>
                </fieldset>
            </div>
            <div className="c-form-item">
                <fieldset>
                <div className="c-form-item__input">
                    <legend className="c-form-item__label u-w-fitcontent">対象情報を指定</legend>
                    <button type="button" className="c-button c-button--xsm c-button--secondary u-ml-md" onClick={handleClear}>
                      <span className="c-button__txt">クリア</span>
                    </button>
                </div>
                <div className="c-form-item__input u-mt-sm">
                    <span className="c-check-wrap">
                    <input type="checkbox" id="chkInfoYosan" value="0" defaultChecked={values.chkInfoYosan==="0"} {...register("chkInfoYosan")}/>
                    <label htmlFor="chkInfoYosan">予算書情報</label>
                    </span>
                    <button type="button" className="c-button c-button--xsm c-button--secondary u-ml-md" aria-label="予算書情報の詳細フィルタを開く" aria-disabled={!watchChkInfoYosan} onClick={handleYosanDialogShow} onKeyDown={(e:KeyboardEvent) => handleYosanKeyDown(e)}>
                    <span className="c-button__txt">予算書情報から絞り込む</span>
                    </button>
                </div>
                {watchChkInfoYosan &&
                <div className="c-form-item__description u-mt-sm">
                    {watchTypeOfBudgetSearchList?.length > 0 &&
                    <div className="c-blk-txt">
                    <p className="u-fw-500">【予算種別】</p>
                    <p>{getTypeOfBudgetSearchTextList(watchTypeOfBudgetSearchList).join('／')}</p>
                    </div>
                    }
                    {watchtTypeOfBudgetYosanItemList?.length > 0 &&
                    <div className="c-blk-txt">
                    <p className="u-fw-500">【冊子名】</p>
                    <p>{getTypeOfBudgetYosanTextList(watchtTypeOfBudgetYosanItemList).join('／')}</p>
                    </div>
                    }
                    {(watchRunningTitleYosanItemList1?.length > 0 || watchRunningTitleYosanItemList2?.length > 0) &&
                    <div className="c-blk-txt c-blk-txt--sm">
                    <p className="u-fw-500">【所管】</p>
                    {watchRunningTitleYosanItemList1?.length > 0 &&
                    <p className="c-text-indent"><span className="c-text-indent__fix">「一般会計」：</span><span>{getRunningTitleYosanTextList1(watchRunningTitleYosanItemList1).join('／')}</span></p>
                    }
                    {watchRunningTitleYosanItemList2?.length > 0 &&
                    <p className="c-text-indent"><span className="c-text-indent__fix">「特別会計」：</span><span>{getRunningTitleYosanTextList2(watchRunningTitleYosanItemList2).join('／')}</span></p>
                    }
                    </div>
                    }
                </div>
                }
                <div className="c-form-item__input u-mt-xs">
                    <span className="c-check-wrap">
                    <input type="checkbox" id="chkInfoKessan" value="0" defaultChecked={values.chkInfoKessan==="0"} {...register("chkInfoKessan")}/>
                    <label htmlFor="chkInfoKessan">決算書情報</label>
                    </span>
                    <button type="button" className="c-button c-button--xsm c-button--secondary u-ml-md"  aria-label="決算書情報の詳細フィルタを開く" aria-disabled={!watchChkInfoKessan} onClick={handleKessanDialogShow} onKeyDown={(e:KeyboardEvent) => handleKessanKeyDown(e)}>
                    <span className="c-button__txt">決算書情報から絞り込む</span>
                    </button>
                </div>
                {watchChkInfoKessan &&
                <div className="c-form-item__description u-mt-sm">
                    {watchtTypeOfBudgetKessanItemList?.length > 0 &&
                    <div className="c-blk-txt">
                    <p className="u-fw-500">【冊子名】</p>
                    <p>{getTypeOfBudgetKessanTextList(watchtTypeOfBudgetKessanItemList).join('／')}</p>
                    </div>
                    }
                    {(watchRunningTitleKessanItemList1?.length > 0 || watchRunningTitleKessanItemList2?.length > 0) &&
                    <div className="c-blk-txt c-blk-txt--sm">
                    <p className="u-fw-500">【所管】</p>
                    {watchRunningTitleKessanItemList1?.length > 0 &&
                    <p className="c-text-indent"><span className="c-text-indent__fix">「決算参照」：</span><span>{getRunningTitleKessanTextList1(watchRunningTitleKessanItemList1).join('／')}</span></p>
                    }
                    {watchRunningTitleKessanItemList2?.length > 0 &&
                    <p className="c-text-indent"><span className="c-text-indent__fix">「特別会計決算参照書」：</span><span>{getRunningTitleKessanTextList2(watchRunningTitleKessanItemList2).join('／')}</span></p>
                    }
                    </div>
                    }
                </div>
                }
                <div className="c-blk-txt c-blk-txt--sm c-blk-txt--split">
                    <ul className="c-list-annotation">
                    <li className="c-text-note">※指定しない場合、全ての予算書情報と決算書情報が検索対象となります。</li>
                    </ul>
                </div>
                </fieldset>
            </div>
        </Accordion>
        </div>
    </form>
    {/** モーダル */}
    <YosanDialog
        id="budgetDocModal"
        ref={yosanDialogRef}
        onClose={handleYosanDialogClose} />
    <KessanDialog
        id="finalAccountDocModal"
        ref={kessanDialogRef}
        onClose={handleKessanDialogClose} />
    </>
    )
};
export default SearchForm;